export default __webpack_public_path__ + "static/media/ant.739adb6a.svg";